// Load Google Font (only in browser)
if (typeof document !== 'undefined') {
  const citizenLightFont = document.createElement('link');
  citizenLightFont.rel = 'stylesheet';
  citizenLightFont.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap';
  document.head.appendChild(citizenLightFont);
}

export const citizenLightNew = {
  name: 'citizen:light',
  extends: 'onify:helix',
  cssPath: 'custom/styles/citizen-light.theme',
  vuetify: {
    defaults: {
      VBtn: {
        variant: 'elevated',
      },
      HBulletin: {
        HActionLink: {
          HScopedBulletinActionBtn: {
            size: 'default',
            variant: 'text',
            color: 'on-surface',
            icon: false,
            appendIcon: 'mdi:mdi-chevron-right',
          },
        },
      },
      HWorkspace: {
        HBulletin: {
          VCard: {
            color: null,
          },
          HActionLink: {
            HScopedBulletinActionBtn: {
              size: 'default',
              variant: 'text',
              icon: false,
              appendIcon: 'mdi:mdi-chevron-right',
            },
          },
        },
      },
      HShortcut: {
        VBadge: {
          color: 'badge-primary',
          inline: true,
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        primary: '#00829b',
        'on-primary': '#FAFAFA',
        secondary: '#9DD5D6',
        'secondary-hover': '#9DD5D6',
        'on-secondary': '#FAFAFA',
        error: '#99092D',
        success: '#2F746B',
        warning: '#D16F00',
        'warning-lighten-1': '#D16F00',
        'warning-lighten-3': '#FFDDB5',

        surface: '#FAFAFA',
        'on-surface': '#001A1B',
        'surface-variant': '#CED1D2',
        'on-surface-variant': '#001A1B',
        'breadcrumb-hover': '#CED1D2',
        background: '#CED1D2',
        'on-background': '#001A1B',
        neutral: '#9DD5D6',
        'on-neutral-100': '#001A1B',
        'on-breadcrumb': '#001A1B',
        'bulletin-board': '#CED1D2',
        'on-bulletin-board': '#001A1B',
        bulletin: '#FAFAFA',
        'on-bulletin': '#001A1B',
        'start-page': '#CED1D2',
        'on-start-page': '#FAFAFA',
        'badge-primary': '#2A6960',
        'badge-tertiary': '#2A6960',
        toolbar: '#2A6960',
        'on-toolbar': '#FFFFFF',

        'header-button': '#FAFAFA',
        'dialog-header-button': '#2A6960',

        // Chips
        'chip-active': '#006160',
        'on-chip-active': '#FFFFFF',

        get 'process-active'() {
          return this.warning;
        },

        get 'process-state-active'() {
          return this.warning;
        },

        get 'on-process-state-active'() {
          return this.surface;
        },

        get 'process-state-inactive'() {
          return this.disabled;
        },

        get 'on-process-state-inactive'() {
          return this.surface;
        },

        get 'process-state-skipped'() {
          return this.primary;
        },

        get 'on-process-state-skipped'() {
          return this.surface;
        },

        get 'process-state-done'() {
          return this.success;
        },

        get 'on-process-state-done'() {
          return this.surface;
        },

        get 'process-state-error'() {
          return this.error;
        },

        get 'on-process-state-error'() {
          return this.surface;
        },

        // Custom:
        fullmakter: '#FFFFFF',

        // Page header background colors
        'page-companies-header-bg': '#CED1D2',
        'on-page-companies-header-bg': '#001A1B',
        'page-properties-header-bg': '#CED1D2',
        'on-page-properties-header-bg': '#001A1B',
        'page-authorizations-header-bg': '#CED1D2',
        'on-page-authorizations-header-bg': '#001A1B',
        'page-children-header-bg': '#CED1D2',
        'on-page-children-header-bg': '#001A1B',
        'page-enrollments-header-bg': '#CED1D2',
        'on-page-enrollments-header-bg': '#001A1B',
        'page-employments-header-bg': '#CED1D2',
        'on-page-employments-header-bg': '#001A1B',
        'page-eservices-header-bg': '#CED1D2',
        'on-page-eservices-header-bg': '#001A1B',
        'page-cases-header-bg': '#CED1D2',
        'on-page-cases-header-bg': '#001A1B',

        // Item card border colors
        'card-assignment': '#2A6960',
        'on-card-assignment': '#FFFFFF',
        'card-company': '#2A6960',
        'card-property': '#2A6960',
        'card-authorization': '#2A6960',
        'card-child': '#2A6960',
        'card-enrollment': '#2A6960',
        'card-employment': '#2A6960',
        'card-case': '#2A6960',
        'card-association': '#808080',
      },
    },
  },
};
